import { useState, useEffect, useContext } from 'react';
import LoginForm from './components/LoginForm';
import VerificationForm from './components/VerificationForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import ChangePasswordForm from './components/ChangePassword';
import logo from '../../assets/images/logo-well.png';
import AuthContext from '../../contexts/auth';

import './style.scss';

const LoginPage = () => {
  const [mode, setMode] = useState(null);
  const { isAuthenticated } = useContext(AuthContext);
  const value = { isAuthenticated };

  useEffect(() => {
    let mode;
    if (window.location.pathname.indexOf('login') > -1) mode = 'login';
    else if (window.location.pathname.indexOf('verification') > -1)
      mode = 'verification';
    else if (window.location.pathname.indexOf('forgot') > -1) mode = 'forgot';
    else if (window.location.pathname.indexOf('new-password') > -1)
      mode = 'newPassword';
    setMode(mode);
  }, []);

  return (
    <AuthContext.Provider value={value}>
      <div className="login-page">
        <div className="login-area">
          <img className="logo" alt="logo" src={logo}></img>
          {(() => {
            switch (mode) {
              case 'login':
                return <LoginForm />;
              case 'forgot':
                return <ForgotPasswordForm />;
              case 'verification':
                return <VerificationForm />;
              case 'newPassword':
                return <ChangePasswordForm />;
              default:
                return 'not found';
            }
          })()}
        </div>
      </div>
    </AuthContext.Provider>
  );
};

export default LoginPage;
